var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefocusColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40006040_28088)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#E5C261"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 62,
    height: 62,
    rx: 9,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1667 34C28.1667 34.766 28.3176 35.5246 28.6107 36.2323C28.9039 36.9401 29.3335 37.5831 29.8752 38.1248C30.4169 38.6665 31.0599 39.0961 31.7677 39.3893C32.4754 39.6824 33.234 39.8333 34 39.8333M28.1667 34C28.1667 33.234 28.3176 32.4754 28.6107 31.7677C28.9039 31.0599 29.3335 30.4169 29.8752 29.8752C30.4169 29.3335 31.0599 28.9039 31.7677 28.6107C32.4754 28.3176 33.234 28.1667 34 28.1667M28.1667 34H26.5M34 39.8333C34.766 39.8333 35.5246 39.6824 36.2323 39.3893C36.9401 39.0961 37.5831 38.6665 38.1248 38.1248C38.6665 37.5831 39.0961 36.9401 39.3893 36.2323C39.6824 35.5246 39.8333 34.766 39.8333 34M34 39.8333V41.5M39.8333 34C39.8333 33.234 39.6824 32.4754 39.3893 31.7677C39.0961 31.0599 38.6665 30.4169 38.1248 29.8752C37.5831 29.3335 36.9401 28.9039 36.2323 28.6107C35.5246 28.3176 34.766 28.1667 34 28.1667M39.8333 34H41.5M34 28.1667V26.5M26.5 26.5L34 34L41.5 41.5M34.4167 34C34.4167 34.2301 34.2301 34.4167 34 34.4167C33.7699 34.4167 33.5833 34.2301 33.5833 34C33.5833 33.7699 33.7699 33.5833 34 33.5833C34.2301 33.5833 34.4167 33.7699 34.4167 34Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40006040_28088",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_40006040_28088"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.45098 0 0 0 0 0.309804 0 0 0 0 0.027451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40006040_28088"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40006040_28088",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefocusColorIcon);
export default __webpack_public_path__ + "static/media/defocusColorIcon.c7de880579203fbc429192ea6e5fc2f3.svg";
export { ForwardRef as ReactComponent };